import { ReactNode } from "react";

export function HeaderFinder(props: { children: ReactNode }) {
  const { children } = props;
  return (
    <div className="flex flex-row gap-2 items-center justify-between px-3 py-[10px] bg-[#F4F5F6] border-b border-b-[#E6E8EC] rounded-t-2xl">
      <div className="flex flex-row gap-2 ">
        <div className="w-3 h-3 rounded-full bg-[#D1D4DC]"></div>
        <div className="w-3 h-3 rounded-full bg-[#D1D4DC]"></div>
        <div className="w-3 h-3 rounded-full bg-[#D1D4DC]"></div>
      </div>
      {children}
      <div className="flex flex-row gap-2 opacity-0 ">
        <div className="w-3 h-3 rounded-full bg-[#D1D4DC]"></div>
        <div className="w-3 h-3 rounded-full bg-[#D1D4DC]"></div>
        <div className="w-3 h-3 rounded-full bg-[#D1D4DC]"></div>
      </div>
    </div>
  );
}
